module.exports = __webpack_public_path__ + "static/media/4S.3454f472.svg";